import { createContext } from 'react';

// Set to true by PortalLayout for every page rendered inside the persistent
// portal shell. PortalHeader reads this to render a slim page-title heading
// (the global chrome — logo, user menu, test toggle — lives in the shell).
const PortalShellContext = createContext(false);

export default PortalShellContext;
